<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/tC8Z3Z/tc-custom/9781569479216.jpg?1705865476560" alt="This image is the cover for the book Since the Layoffs"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Since the Layoffs
      </h1>
      <p class="bookDescription body article font2">
        <b>This “dark, satirical comedy [is] written with the deadpan humor Levison used so well in his first book, <i>A Working Stiff’s Manifesto</i>” (<i>USA Today</i>).</b><br/>  <br/> Jake Skowran has been laid off from his job as a factory supervisor. Fortunately, he’s been offered other work. Unfortunately, it is as a hired killer.<br/>  <br/> Beset by creditors and filled with fury over his situation, Jake decides he has little choice except to take it. He is going to carve off a piece of the economy or die trying . . .<br/>  <br/> “Like Donald Westlake in <i>The Ax</i>, about an insurance executive turned hit man, Levison brings a burning rage to this accomplished debut novel.” —<i>Booklist</i><br/>  <br/> “[A] black comedy of morals cracking in a lousy economy.” —<i>The New York Times Book Review</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Iain Levison
      </h2>
      
      <p class="authorDescription body article">Iain Levison is the author of <I>A Working Stiff&rsquo;s Manifesto</I>, an account of his post-collegiate work experience, consisting of forty-two jobs in ten years, and of two previous novels, <I>Since the Layoffs</I> and <I>Dog Eats Dog</I>. He lives in Raleigh, North Carolina.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Soho Press, Inc.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?203e6ecc